import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
